module.exports = __webpack_public_path__ + "img/logo-default-200x34.4a1bc46b.png";